import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  MyTripFindTripBy,
  SearchTrip
} from '@com-delta-idp/mnx-capability-trip-management-ui';
import {
  MyTripAem,
  WindowUtilsService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { UPCOMING_TRIPS_URL } from '../constants/my-trip-constants';
import { CreditCardService } from '../facades/credit-card.facade.service';
import { SearchFacade } from '../facades/search.facade';
import { UPC_SYS_ERR } from '../models/enums/my-trip.enums';
import { TripsFormValues } from '../models/interface/generic-form.interface';
import { updateValidators } from '../utils/mytrip-form.validator.utils';

@Injectable({
  providedIn: 'root'
})
export class MyTripFormService {
  constructor(
    private cardService: CreditCardService,
    private window: WindowUtilsService,
    private searchFacade: SearchFacade
  ) {}

  onFindTripByChange(findTripBy: string, tripForm: UntypedFormGroup): void {
    updateValidators(findTripBy, tripForm);
    tripForm.markAsPristine();
  }

  onSubmitActionForm(content: SearchTrip): void {
    const currentType = content.currentType;
    const formValues = content.formGroup.value;

    if (this.isConfirmationOrTicketSearch(currentType)) {
      this.handleConfirmationOrTicketSearch(currentType, formValues);
    } else if (currentType === MyTripFindTripBy.CREDIT_CARD_NUMBER) {
      this.handleCreditCardSearch(formValues);
    }
  }

  private isConfirmationOrTicketSearch(currentType: string): boolean {
    return (
      currentType === MyTripFindTripBy.CONFIRMATION_NUMBER ||
      currentType === MyTripFindTripBy.TICKET_NUMBER
    );
  }

  private handleConfirmationOrTicketSearch(
    currentType: string,
    formValues: TripsFormValues
  ): void {
    this.searchFacade.findTrip({
      recordLocator: formValues.confirmationNo || formValues.eTicketNo || '',
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      searchType: currentType
    });
  }

  private handleCreditCardSearch(formValues: TripsFormValues): void {
    this.cardService.getCardReferenceId({
      cardNo: formValues.creditCardNo || '',
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      searchOption: '',
      tab: MyTripFindTripBy.CREDIT_CARD_NUMBER
    });
  }

  viewAllTrips = (): void => this.window.location(UPCOMING_TRIPS_URL);

  getGenericErrorMessage(myTripStaticContent: MyTripAem): string {
    return (
      myTripStaticContent?.errors.find((err) => err.errorId === UPC_SYS_ERR)
        ?.errorMessageDescription ?? ''
    );
  }
}
